export default "__VITE_ASSET__DTNqJ6gy__"